import { Nullable } from '@internal-libraries/kheops-ui-lib'
import { AnesthesiaTypeDto } from '../Type/AnesthesiaTypeDto'
import { AnesthesiaTypeData } from '../Type/AnesthesiaTypeData'

export default class ClvrAnesthesiaType {
    public id: Nullable<number> = null
    public name = ''

    public constructor(data?: AnesthesiaTypeData) {
        if (data) {
            Object.assign(this, data)
        }
    }

    public toDto(): AnesthesiaTypeDto {
        return {
            id: this.id,
            name: this.name,
        }
    }
}
